<template>
  <div class="detail flex flex-row">
    <div class="detail-left">
      <img
        :src="info.checkmallWaresLogo"
        v-if="info.checkmallWaresLogo"
        class="detail-cover"
      />
      <img v-else :src="$oss('common/empty-img.png')" class="detail-cover" />
    </div>
    <div class="detail-right flex-1">
      <div class="detail-title flex flex-middle">
        <h3>{{ info.checkmallWaresName }}</h3>
        <div>
          <el-tag type="success" size="small">交易担保</el-tag>
          <el-tag type="success" size="small">快速测试</el-tag>
          <el-tag type="success" size="small">结果分析</el-tag>
        </div>
      </div>
      <div class="flex">
        <div class="detail-line" v-if="info.checkmallWaresBrand">
          <label>品牌</label>
          <span>{{ info.checkmallWaresBrand }}</span>
        </div>
        <div class="detail-line" v-if="info.checkmallWaresModel">
          <label>型号</label><span>{{ info.checkmallWaresModel }}</span>
        </div>
        <div class="detail-line">
          <label>模式</label>
          <span>{{ info.checkmallWaresPattern }}</span>
        </div>
      </div>
      <div class="specs flex flex-row">
        <div class="specs-left">规格</div>
        <div class="flex-1">
          <Specs :info="info.serviceProject" :unitMap="unitMap" />
        </div>
      </div>
      <div class="flex">
        <el-button type="primary" @click="toOrderPage" size="medium"
          >立即下单</el-button
        >
        <!-- <el-button
          type="warning"
          @click="toCollect"
          plain
          icon="el-icon-star-off"
          >{{ info.isCollect ? "已" : "" }}收藏服务</el-button
        > -->
      </div>
    </div>
  </div>
</template>
<script>
import Specs from "./Specs.vue";
import { mapGetters } from "vuex";
import { getBusinessCustomerServer } from "@/api/userCenter";
import { collectSomething, deleteCollect } from "@/api/common";
import { COLLECT_TYPE } from "@/constant/dict";
export default {
  name: "detail",
  components: {
    Specs,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    unitMap: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(["token", "userBaseInfo"]),
  },
  data() {
    return {};
  },
  methods: {
    toOrderPage() {
      if (!this.token) {
        this.$store.dispatch("login");
        return;
      }
      this.$router.push({
        name: "deviceOrder",
        query: { id: this.info.checkmallWaresId },
      });
    },
    async toCollect() {
      if (!this.token) {
        this.$store.dispatch("login");
        return;
      }
      const api = this.info.isCollect ? deleteCollect : collectSomething;
      this.$axios.post(api, {
        collectType: COLLECT_TYPE.service,
        resourceId: this.info.checkmallWaresId,
      });
      if (this.info.isCollect) {
        this.$message.success("已取消收藏");
        const no = 0;
        this.info.isCollect = no;
      } else {
        this.$message.success("收藏成功");
        const yes = 1;
        this.info.isCollect = yes;
      }
    },
    // 联系客服
    toContact() {
      if (!this.token) {
        this.$store.dispatch("login");
        return;
      }
      this.getCustomer();
    },
    async getCustomer() {
      const { checkmallBusinessId } = this.info;
      const res = await this.$axios.post(getBusinessCustomerServer, {
        businessId: checkmallBusinessId,
        businessType: "1",
      });
      if (res) {
        if (res.userId === this.userBaseInfo.userId) {
          this.$message.error("不能咨询自己");
          return;
        }
        this.$emit("openConsult", res);
      } else {
        this.$message.info("该商城暂时还没有客服");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
$line-color: #f0f0f0;
.detail {
  background: white;
  padding: 20px;
  &-left {
    width: 200px;
  }
  &-cover {
    width: 200px;
    height: 200px;
    object-fit: cover;
  }
  &-right {
    padding-left: 20px;
  }
  &-title {
    margin-bottom: 15px;
    h3 {
      font-size: 24px;
      color: #333;
      margin-right: 20px;
    }
    > div {
      span {
        margin: 5px 0 5px 10px;
      }
    }
    i {
      margin-right: 4px;
      font-size: 15px;
    }
  }
  &-line {
    margin-right: 60px;
    label {
      margin-right: 15px;
      color: #999;
    }
    span {
      font-size: 12px;
    }
  }
}
.specs {
  margin-bottom: 8px;
  &.el-collapse {
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    padding: 0 10px 10px 10px;
    margin-top: 15px;
  }
  &-left {
    width: 45px;
    line-height: 40px;
    color: #999;
  }
}
.promise {
  > label {
    margin-right: 20px;
  }
  /deep/ .el-tag {
    margin-right: 15px;
  }
}
</style>
